import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { inr } from "@/lib/api";

export default function ProductCard({ p, index = 0, variantColor = "", variantImage = "" }) {
  const discount = p.mrp > p.price ? Math.round(((p.mrp - p.price) / p.mrp) * 100) : 0;
  const img = variantImage || p.images?.[0];
  const to = variantColor ? `/product/${p.id}?color=${encodeURIComponent(variantColor)}` : `/product/${p.id}`;
  const tid = variantColor ? `${p.sku}-${variantColor.toLowerCase().replace(/[^a-z0-9]+/g, "-")}` : p.sku;
  return (
    <Link to={to} className="group block fade-up" style={{ animationDelay: `${(index % 8) * 60}ms` }} data-testid={`product-card-${tid}`}>
      <div className="relative overflow-hidden rounded-xl bg-white hover-lift rw-tilt">
        <div className="aspect-[3/4] overflow-hidden">
          <img src={img} alt={p.name} className="img-cover group-hover:scale-110 transition-transform duration-700 ease-out" />
        </div>
        <div className="absolute top-3 left-3 flex flex-col gap-1.5">
          {p.is_bestseller && <span className="bg-rose-950 text-amber-50 text-[10px] font-accent font-semibold px-2.5 py-1 rounded-full uppercase tracking-wider">Bestseller</span>}
          {p.is_new && <span className="bg-amber-600 text-white text-[10px] font-accent font-semibold px-2.5 py-1 rounded-full uppercase tracking-wider">New</span>}
        </div>
        {discount > 0 && <span className="absolute top-3 right-3 bg-emerald-600 text-white text-[10px] font-accent font-bold px-2 py-1 rounded-full">{discount}% OFF</span>}
      </div>
      <div className="pt-3">
        <p className="accent-label !text-[0.6rem] !tracking-[0.2em] text-amber-700">{p.category}</p>
        <h3 className="font-medium text-sm mt-1 leading-tight group-hover:text-rose-950 transition-colors">{p.name}{variantColor && <span className="text-rose-950/60"> — {variantColor}</span>}</h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="font-serif text-base font-semibold text-rose-950">{inr(p.price)}</span>
          {discount > 0 && <span className="text-xs text-muted-foreground line-through">{inr(p.mrp)}</span>}
          <span className="ml-auto flex items-center gap-0.5 text-xs text-amber-600"><Star className="w-3 h-3 fill-amber-500 text-amber-500" />{p.rating}</span>
        </div>
      </div>
    </Link>
  );
}
